<template>
  <el-dialog :title="requiresArchiveNo ? '纸质存档确认' : '财务确认'" :visible.sync="visible" width="420px">
    <p class="tips">{{ requiresArchiveNo ? '请确认纸质合同已经完成归档。' : '请确认纸质合同与系统中数据一致？' }}</p>
    <el-form v-if="requiresArchiveNo" ref="archiveForm" :model="data" :rules="rules" label-width="80px">
      <el-form-item label="档案号" prop="archiveNo">
        <el-input v-model.trim="data.archiveNo" maxlength="64" show-word-limit placeholder="请输入纸质合同档案号" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changeStatus } from "@/api/crm/contract";

export default {
  name: "FinanceConfirm",
  props: {
  },
  data() {
    return {
      visible: false,
      requiresArchiveNo: false,
      data: {
        contractId: null,
        operateType: 4,
        archiveNo: ''
      },
      rules: {
        archiveNo: [
          { required: true, message: '请输入档案号', trigger: 'blur' },
          { max: 64, message: '档案号不能超过64个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    options (id, archiveNo, requiresArchiveNo) {
      if (!id) {
        this.msgError("当前合同id异常")
        return
      }
      this.data.contractId = id
      this.data.archiveNo = archiveNo || ''
      this.requiresArchiveNo = Boolean(requiresArchiveNo)
      this.visible = true
      this.$nextTick(() => this.$refs.archiveForm && this.$refs.archiveForm.clearValidate())
    },
    confirm () {
      if (!this.requiresArchiveNo) {
        this.submitConfirm()
        return
      }
      this.$refs.archiveForm.validate(valid => {
        if (!valid) return
        this.submitConfirm()
      })
    },
    submitConfirm () {
        const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
        });
        changeStatus(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess(this.requiresArchiveNo ? "纸质存档确认成功" : "财务确认成功");
        }).catch(error => {
            loading.close()
        })
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
    font-size: 16px;
}
</style>
